const BASE_URL = 'https://hook.integromat.com/p8e3dk1172a176qnr3e8cmtp45ro747w';


export async function getSearchUser(email) {
 
  const param = {
    type: 'EmailSearch',
    variable: email
  };

  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(param)
  });
  const responseJson = await response.json();

  return responseJson;
}

export async function setInteraction(id) {
 
  const param = {
    type: 'RecordVisit',
    variable: id
  };

  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(param)
  });
  const responseJson = await response.json();

  return responseJson;
}

export async function setDR(id) {
 
  const param = {
    type: 'UpdateDR',
    variable: id
  };

  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(param)
  });
  const responseJson = await response.json();

  return responseJson;
}

export async function setDRPlugin(id) {
 
  const param = {
    type: 'DRPlugin',
    variable: id
  };

  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(param)
  });
  const responseJson = await response.json();

  return responseJson;
}

export async function HomeRequestSubmission(data) {
 
  const param = {
    type: 'HomeRequest',
    variable: data
  };

  const response = await fetch(BASE_URL, {
    method: 'POST',
    // headers: {
    //   'Content-Type': 'multipart/form-data'
    // },
    body: param
  });
  const responseJson = await response.json();

  return responseJson;
}

export async function ConsentDSSubmission(first,last,email) {
 
  const param = {
    type: 'ConsentDS',
    fist: first,
    last: last,
    email: email,
  };

  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(param)
  });
  const responseJson = await response.json();

  return responseJson;
}

// export async function getExtendRegistrant(registrantId, projectId) {
//   const HEADERS = headers(projectId);
//   const response = await fetch(
//     PROXY + BASE_URL + REGISTRANTS + `/${registrantId}`,
//     {
//       headers: HEADERS,
//     }
//   );
//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function setHistory(registrantId, type, projectId) {
//   const HEADERS = headers(projectId);
//   const dataBody = {
//     type: type,
//     subject: 'Register at Sales Centre',
//   };
//   const response = await fetch(
//     PROXY + BASE_URL + REGISTRANTS + `/${registrantId}/histories`,
//     {
//       method: 'POST',
//       headers: HEADERS,
//       body: JSON.stringify(dataBody),
//     }
//   );
//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function updateHistory(registrantId, historyId, type, projectId) {
//   const HEADERS = headers(projectId);
//   const dataBody = {
//     type: type,
//     subject: 'Register at Sales Centre',
//   };
//   const response = await fetch(
//     PROXY + BASE_URL + REGISTRANTS + `/${registrantId}/histories/${historyId}`,
//     {
//       method: 'PUT',
//       headers: HEADERS,
//       body: JSON.stringify(dataBody),
//     }
//   );
//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function getRegistrant(registrantId, projectId) {
//   const HEADERS = headers(projectId);
//   const response = await fetch(
//     PROXY + BASE_URL + REGISTRANTS + `/${registrantId}`,
//     {
//       headers: HEADERS,
//     }
//   );
//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function getLatestRegistrant(projectId) {
//   const HEADERS = headers(projectId);
//   const response = await fetch(PROXY + BASE_URL + REGISTRANTS, {
//     headers: HEADERS,
//   });
//   const responseJson = await response.json();

//   return responseJson;
// }

// export default async function createARegistrant(projectId) {
//   const HEADERS = headers(projectId);
//   const firstName = document.getElementById('firstName').value;
//   const lastName = document.getElementById('lastName').value;
//   const email = document.getElementById('email').value;
//   const phone = document.getElementById('phone').value;
//   const postal = document.getElementById('postal').value;

//   const realtor = document.getElementById('realtor');
//   const realtorValue = realtor.options[realtor.selectedIndex].value;

//   const howHeard = document.getElementById('howHeard');
//   const howHeardValue = howHeard.options[howHeard.selectedIndex].value;

//   const typeOfHomeValues = Array.from(
//     document.querySelectorAll('input[name="typeofhome"]')
//   )
//     .filter((checkbox) => checkbox.checked)
//     .map((checkbox) => {
//       return { answer: checkbox.value, answerId: checkbox.id };
//     });

//   const dataBody = {
//     person: {
//       firstName: firstName,
//       lastName: lastName,
//     },
//     emails: [
//       {
//         email: email,
//         primary: true,
//       },
//     ],
//     phones: [
//       {
//         phone: phone,
//         primary: true,
//       },
//     ],
//     addresses: [
//       {
//         zipCode: postal,
//         primary: true,
//       },
//     ],
//     questions: [
//       {
//         questionId: '80244',
//         name: 'Home Type',
//         answers: typeOfHomeValues,
//       },
//       {
//         questionId: '80243',
//         name: 'How Heard',
//         answers: [
//           {
//             answer: howHeardValue,
//           },
//         ],
//       },
//       {
//         questionId: '80246',
//         name: 'Realtor',
//         answers: [
//           {
//             answer: realtorValue,
//           },
//         ],
//       },
//       {
//         questionId: '80248',
//         name: 'Consent',
//         answers: [
//           {
//             answer: 'Yes',
//           },
//         ],
//       },
//     ],
//     history: [
//       {
//         type: 'Visit',
//         subject: 'Register at Sales Centre',
//       },
//     ],
//     sourceType: {
//       sourceType: 'Online Registration',
//     },
//   };

//   const response = await fetch(PROXY + BASE_URL + REGISTRANTS, {
//     method: 'POST',
//     headers: HEADERS,
//     body: JSON.stringify(dataBody),
//   });

//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function createARegistrantOffices() {
//   const HEADERS = headers('offices');
//   const firstName = document.getElementById('firstName').value;
//   const lastName = document.getElementById('lastName').value;
//   const email = document.getElementById('email').value;
//   const phone = document.getElementById('phone').value;
//   const postal = document.getElementById('postal').value;
//   const brokerage = document.getElementById('brokerage').value;
//   const realtorName = document.getElementById('realtorName').value;
//   const typeOfBusiness = document.getElementById('typeOfBusiness').value;

//   const realtor = document.getElementById('realtor');
//   const realtorValue = realtor.options[realtor.selectedIndex].value;

//   const workWithRealtor = document.getElementById('workingWithRealtor');
//   const workWithRealtorValue =
//     workWithRealtor.options[workWithRealtor.selectedIndex].value;

//   const preferredSize = document.getElementById('preferredSize');
//   const preferredSizeValue =
//     preferredSize.options[preferredSize.selectedIndex].value;

//   const howHeard = document.getElementById('howHeard');
//   const howHeardValue = howHeard.options[howHeard.selectedIndex].value;

//   const ownerUsage = document.getElementById('ownerUsage');
//   const ownerUsageValue = ownerUsage.options[ownerUsage.selectedIndex].value;

//   const dataBody = {
//     person: {
//       firstName: firstName,
//       lastName: lastName,
//     },
//     emails: [
//       {
//         email: email,
//         primary: true,
//       },
//     ],
//     phones: [
//       {
//         phone: phone,
//         primary: true,
//       },
//     ],
//     addresses: [
//       {
//         zipCode: postal,
//         primary: true,
//       },
//     ],
//     questions: [
//       {
//         questionId: '109713',
//         name: 'Preferred Size',
//         answers: [
//           {
//             answer: preferredSizeValue,
//           },
//         ],
//       },
//       {
//         questionId: '109712',
//         name: 'How Heard',
//         answers: [
//           {
//             answer: howHeardValue,
//           },
//         ],
//       },
//       {
//         questionId: '109714',
//         name: 'Owner Usage or Investment',
//         answers: [
//           {
//             answer: ownerUsageValue,
//           },
//         ],
//       },
//       {
//         questionId: '109716',
//         name: 'Realtor',
//         answers: [
//           {
//             answer: realtorValue,
//           },
//         ],
//       },
//       {
//         questionId: '109718',
//         name: 'Working with Realtor',
//         answers: [
//           {
//             answer: workWithRealtorValue,
//           },
//         ],
//       },
//       {
//         questionId: '109715',
//         name: 'Type of Business',
//         answers: [
//           {
//             answer: typeOfBusiness,
//           },
//         ],
//       },
//       {
//         questionId: '109717',
//         name: 'Brokerage',
//         answers: [
//           {
//             answer: brokerage,
//           },
//         ],
//       },
//       {
//         questionId: '109719',
//         name: `Realtor's Name`,
//         answers: [
//           {
//             answer: realtorName,
//           },
//         ],
//       },
//       {
//         questionId: '109720',
//         name: 'Consent',
//         answers: [
//           {
//             answer: 'Yes',
//           },
//         ],
//       },
//     ],
//     history: [
//       {
//         type: 'Visit',
//         subject: 'Register at Sales Centre',
//       },
//     ],
//     sourceType: {
//       sourceType: 'Online Registration',
//     },
//   };

//   const response = await fetch(PROXY + BASE_URL + REGISTRANTS, {
//     method: 'POST',
//     headers: HEADERS,
//     body: JSON.stringify(dataBody),
//   });

//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function updateRegistrantContactInformation(
//   registrantId,
//   projectId
// ) {
//   const HEADERS = headers(projectId);
//   const firstName = document.getElementById('firstName').value;
//   const lastName = document.getElementById('lastName').value;
//   const email = document.getElementById('email').value;
//   const phone = document.getElementById('phone').value;
//   const postal = document.getElementById('postal').value;

//   const dataBody = {
//     firstName: firstName,
//     lastName: lastName,
//     emails: [
//       {
//         email: email,
//         primary: true,
//       },
//     ],
//     phones: [
//       {
//         phone: phone,
//         primary: true,
//       },
//     ],
//     addresses: [
//       {
//         zipCode: postal,
//         primary: true,
//       },
//     ],
//   };
//   const response = await fetch(
//     PROXY +
//       BASE_URL +
//       REGISTRANTS +
//       `/${registrantId}/person/contact-information`,
//     {
//       method: 'PUT',
//       headers: HEADERS,
//       body: JSON.stringify(dataBody),
//     }
//   );
//   const responseJson = await response.json();

//   return responseJson;
// }

// export async function updateRegistrantQuestionAnswers(
//   registrantId,
//   questionId,
//   questionDOMValue,
//   projectId,
//   isArray
// ) {
//   const HEADERS = headers(projectId);
//   const dataBody = {
//     answers: [],
//   };
//   if (isArray) {
//     questionDOMValue.map((item) => dataBody.answers.push(item));
//   } else {
//     dataBody.answers.push({ answer: questionDOMValue });
//   }

//   const response = await fetch(
//     PROXY + BASE_URL + REGISTRANTS + `/${registrantId}/questions/${questionId}`,
//     {
//       method: 'PUT',
//       headers: HEADERS,
//       body: JSON.stringify(dataBody),
//     }
//   );
//   const responseJson = await response.json();

//   return responseJson;
// }
